import { Directive, HostListener, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Directive({
  selector: '[appModal]'
})
export class ModalDirective {

  @Input() component: any;
  @Input() props?: { [key: string]: string | number };

  constructor(private modalService: NgbModal) { }

  @HostListener('click') onClick() {
    this.openModal();
  }

  openModal() {
    let modalRef = this.modalService.open(this.component, { size: 'm' });
    if (this.props) {
      Object.assign(modalRef.componentInstance, this.props);
    }
  }
}
